/* IMPORT */
import adjustChannel from './adjust_channel.js';
/* MAIN */
const desaturate = (color, amount) => {
    return adjustChannel(color, 's', -amount);
};
/* EXPORT */
export default desaturate;
